import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BookedDetailsComponent } from '../booked-details/booked-details.component';
import { BookingData } from '../models/booking-data';
import { AdminBookingsService } from '../service/admin-bookings.service';
import { AppConstants } from '../AppConstants';
import { BookSelectedSlotsComponent } from '../book-selected-slots/book-selected-slots.component';
import { AddToCartComponent } from '../add-to-cart/add-to-cart.component';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-booking-slots',
  templateUrl: './booking-slots.component.html',
  styleUrls: ['./booking-slots.component.css']
})
export class BookingSlotsComponent implements OnInit, OnDestroy {
  @Input() showFullDay;
  @Input() selectedDate;
  @Input() selectedProduct;
  @Input() venueName;

  dateRange = 7;
  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  dataSource = [];
  origDataSource = [];
  columnData = [];
  dayColumnsObj = [];
  dayColumns = [];
  slotDetails: any = {};
  slotInterval = 60;
  bookingData: BookingData;
  bookingSlotsSubscription: Subscription;
  user: any;
  singleClickTimeout: any;
  isSingleClick = false;
  rupeeSign = 'Rs.';
  reloadDataSubscription: Subscription;
  selectedSlotRemovedSubscription: Subscription;
  venueDuration = {
    startTime: '',
    endTime: ''
  };
  venues: any[] = [];
  selectedSlot: any = null;
  slotMenuTrigger: any;
  pageRefreshSubscriber: Subscription;
  isMobile = false;
  isLoading = false;

  constructor(private cd: ChangeDetectorRef, private dialog: MatDialog, private adminBookingSvc: AdminBookingsService, private snackBar: MatSnackBar) {

    this.pageRefreshSubscriber = this.adminBookingSvc.getRefreshPage().subscribe(res => {
      if (res) {
        this.initializeData();
      }
    })
  }

  ngOnChanges(changes) {

    this.isMobile = window.innerWidth < 768;
    if (changes && (changes.selectedDate && !changes.selectedDate.firstChange &&
      changes.selectedDate.previousValue !== changes.selectedDate.currentValue) ||
      (changes.showFullDay && !changes.showFullDay.firstChange &&
        changes.showFullDay.previousValue !== changes.showFullDay.currentValue)) {
      this.refreshGrid();
    }
    if (changes && changes.selectedProduct && !changes.selectedProduct.firstChange &&
      changes.selectedProduct.previousValue !== changes.selectedProduct.currentValue) {
      this.slotInterval = this.selectedProduct.durationPerSlot;
      this.refreshGrid();
    }
  }

  addZeroIfRequired(value: number) {
    if (value > 9) {
      return value;
    }
    return '0' + value;
  }

  ngOnInit() {
    this.slotInterval = this.selectedProduct.durationPerSlot;
    this.setAllDayHoursInSource();
    this.initializeData();
    this.reloadDataSubscription = this.adminBookingSvc.reloadData.subscribe((data: any) => {
      if (data.reloadData) {
        this.initializeData();
      }
    });
    this.selectedSlotRemovedSubscription = this.adminBookingSvc.selectedSlotRemoved.subscribe((slotData: any) => {
      const element = this.dataSource.find(el => el.dateTime === slotData.dateTime);
      // this.showData(element, slotData.date, null);
      setTimeout(() => {
        this.ngOnInit();
      }, 1000);
    });
  }

  initializeData() {
    if (this.selectedDate && this.selectedProduct) {
      this.bookingSlotsSubscription?.unsubscribe();
      this.isLoading = true;
      this.user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT));
      if (AppConstants.SESSION_STORAGE_ROLEID == 1) {
        console.log("Tenant Id Venues ", AppConstants.SESSION_STORAGE_TENANTID);
        this.user.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
        console.log("Tenant Id ", this.user.tenantId);
        //console.log("user", this.user);
      }

      const endDate = this.addXNumberOfDays(this.selectedDate, 7);
      /* endDate.setFullYear(this.selectedDate.getFullYear());
      endDate.setMonth(this.selectedDate.getMonth());
      endDate.setDate(this.selectedDate.getDate() + 7); */
      const startDateStr = this.selectedDate.getFullYear() + '-' + this.addZeroIfRequired(this.selectedDate.getMonth() + 1) + '-' +
        this.addZeroIfRequired(this.selectedDate.getDate());
      const endDateStr = endDate.getFullYear() + '-' + this.addZeroIfRequired(endDate.getMonth() + 1) + '-' + this.addZeroIfRequired(endDate.getDate());
      const params = {
        tenantId: this.user.tenantId,
        productId: this.selectedProduct.id,
        startDate: startDateStr,
        endDate: endDateStr
      };
      if (this.selectedProduct.type === AppConstants.SINGLE_SESSION) {
        this.bookingSlotsSubscription = this.adminBookingSvc.getSingleSessionBookingSlots(params).subscribe((response: any) => {
          console.log("Booking Data of All the venues", response);
          this.bookingData = this.getBookingDataForCurrentVenue(response, 'singleBookingAvailableSlots', 'singleBookingBookedSlots');
          console.log("#####33333", this.bookingData)
          this.renderGrid();
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      } else {
        this.bookingSlotsSubscription = this.adminBookingSvc.getMultiSessionBookingSlots(params).subscribe((response: any) => {
          console.log(response);
          this.bookingData = this.getBookingDataForCurrentVenue(response, 'multiBookingAvailableSlots', 'multiBookingBookedSlots');
          console.log("#####55555555", this.bookingData)
          this.renderGrid();
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      }
    }
  }

  addXNumberOfDays(startDate: Date, numberOfDays: number): Date {
    // Set the time to midnight (00:00:00)
    startDate.setHours(0, 0, 0, 0);

    const millisecondsInSevenDays = numberOfDays * 24 * 60 * 60 * 1000;
    const futureDate = new Date(startDate.getTime() + millisecondsInSevenDays);
    return futureDate;
  }


  getBookingDataForCurrentVenue(bookingData, availableSlots, bookedSlots) {
    const currentVenueData = new BookingData();
    currentVenueData.venueName = this.venueName;

    if (bookingData && bookingData.length > 0) {
      bookingData.forEach((venueData) => {
        if (venueData.venueName === this.venueName) {
          currentVenueData.availableSlots.splice(currentVenueData.availableSlots.length, 0,
            ...venueData[availableSlots]);
          currentVenueData.bookedSlots.splice(currentVenueData.bookedSlots.length, 0,
            ...venueData[bookedSlots]);

        }
      });
    }

    return currentVenueData;
  }

  refreshGrid() {
    this.dataSource = [];
    this.setAllDayHoursInSource();
    this.initializeData();
  }

  setVenueDuration() {
    const timings = this.bookingData.availableSlots.map((slot) => slot.startTime);
    //console.log ("Available Slots", this.bookingData.availableSlots);

    console.log("Booked Slots", this.bookingData.bookedSlots);
    const updatedTimings = [
      ...timings,
      ...this.bookingData.bookedSlots.map((slot) => slot.startTime)
    ];
    console.log('updatedTimings ', this.bookingData.bookedSlots, updatedTimings);
    const uniqueTimings = updatedTimings.filter((time, pos) => updatedTimings.indexOf(time) === pos);
    //console.log('unique timings', uniqueTimings);
    console.log('available timings' + JSON.stringify(uniqueTimings));
    const sortTimings = uniqueTimings.sort((a, b) => {
      const splitA = a.split(':');
      const splitB = b.split(':');
      return parseInt(splitA[0], 10) - parseInt(splitB[0], 10);
    });
    console.log('sort timings - ' + JSON.stringify(sortTimings));
    this.venueDuration = {
      startTime: sortTimings[0],
      endTime: sortTimings[sortTimings.length - 1]
    };
    console.log('venue name: ' + this.venueName + ' - duration: ' + JSON.stringify(this.venueDuration));
    const newDataSource = [];
    let canAddData = true;
    this.dataSource.forEach((ds) => {
      if (canAddData && (newDataSource.length > 0 && ds.dateTime !== this.venueDuration.endTime) || ds.dateTime === this.venueDuration.startTime) {
        newDataSource.push(ds);
      } else if (ds.dateTime === this.venueDuration.endTime) {
        newDataSource.push(ds);
        canAddData = false;
      }
    });
    this.dataSource = newDataSource;
    console.log('new data source - ', this.dataSource, JSON.stringify(this.dataSource));
  }

  renderGrid() {
    if (!this.showFullDay) {
      this.setVenueDuration();
    }
    this.slotDetails = {};
    this.columnData = ['dateTime'];
    this.dayColumns = this.getDayColumns();
    this.columnData = this.columnData.concat(this.dayColumns);
    this.formSlotData();
    this.updateDataSource();
    this.cd.detectChanges();
  }

  // ✅ Handle single click on slot for single-slot setup
  onSingleClick(element: any, dataKey: string, event: MouseEvent, venue: string = 'default', action?: 'view' | 'add' | 'delete'): void {
    this.isSingleClick = true;
    this.singleClickTimeout = setTimeout(() => {
      if (this.isSingleClick) {
        this.showData(element, dataKey, event, venue, action);
      }
    }, 200);
  }

  // ✅ Show data with action-based logic (same as multi-slot behavior)
  showData(element: any, dataKey: string, event: MouseEvent, venue: string = 'default', action?: 'view' | 'add' | 'delete'): void {
    const slotClicked = element[dataKey]?.[venue];
    console.log(action)
    if (!slotClicked) return;

    // Open modal for booked slot
    if (action === 'view') {
      this.dialog.open(BookedDetailsComponent, {
        data: slotClicked,
        width: this.isMobile ? '95vw' : '600px',
        height: this.isMobile ? '90vh' : '650px',
        maxWidth: this.isMobile ? '95vw' : '600px'
      });
      return;
    }

    // Add to Cart logic
    // if (action === 'add') {
    //   if (this.selectedProduct.capacityPerVenue > 1) {
    //     const dialogRef = this.dialog.open(AddToCartComponent, {
    //       data: { slot: slotClicked, selectedProduct: this.selectedProduct }
    //     });

    //     dialogRef.afterClosed().subscribe(result => {
    //       if (result && typeof result === 'number' && result > 0) {
    //         slotClicked.isSelected = true;

    //         let i = 0;
    //         const processWithDelay = () => {
    //           if (i < result && slotClicked.availableSlots?.length) {
    //             this.logicForAddRemove(slotClicked.availableSlots[0]);
    //             i++;
    //             setTimeout(processWithDelay, 500);
    //           }
    //         };

    //         processWithDelay();
    //       }
    //     });
    //   } else {
    //     if (slotClicked.availableSlots?.length) {
    //       slotClicked.isSelected = !slotClicked.isSelected;
    //       this.logicForAddRemove(slotClicked.availableSlots[0]);
    //     }
    //   }
    //   return;
    // }

    // Add only single slot at a time logic
    if (action == 'add') {
      let selectedSlots = JSON.parse(sessionStorage.getItem('selectedSlots') || '[]');

      // Guard: slotClicked and necessary properties must exist
      if (!slotClicked || !this.selectedProduct) {
        this.snackBar.open('Something went wrong. Please try again.', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-error']
        });
        return;
      }

      // Guard: availableSlots check
      if (!Array.isArray(slotClicked.availableSlots) || slotClicked.availableSlots.length === 0) {
        this.snackBar.open('No available slots found for this selection.', 'Close', {
          duration: 3000,
          panelClass: ['snackbar-error']
        });
        return;
      }

      // MULTI SLOT CASE
      // if (this.selectedProduct.capacityPerVenue > 1) {
      //   const slotUniqueId = slotClicked.availableSlots[0]?.uniqueId;

      //   // Scenario 1: Booked slots exceed capacity
      //   if (Array.isArray(slotClicked.bookedSlots) && slotClicked.bookedSlots.length >= this.selectedProduct.capacityPerVenue) {
      //     console.log("Scenario 1 - Booked full");
      //     this.snackBar.open('This selected slot is fully booked!', 'Close', {
      //       duration: 3000,
      //       panelClass: ['snackbar-error']
      //     });
      //     return;
      //   }

      //   // Scenario 2: Already selected same slot count exceeds capacity
      //   const alreadySelectedCount = selectedSlots.filter(slot => slot.uniqueId === slotUniqueId).length;
      //   if (alreadySelectedCount >= this.selectedProduct.capacityPerVenue) {
      //     console.log("Scenario 2 - Already selected full");
      //     this.snackBar.open('The capacity for this slot is already full. Please choose a different slot.', 'Close', {
      //       duration: 3000,
      //       panelClass: ['snackbar-error']
      //     });
      //     return;
      //   }

      //   // Scenario 3: Safe to proceed with selection
      //   console.log("Scenario 3 - Slot selected");
      //   slotClicked.isSelected = true;
      //   slotClicked.availableSlots[0].isSelected = false;
      //   this.logicForAddRemove(slotClicked.availableSlots[0]);
      //   return;
      // }

      if (this.selectedProduct.capacityPerVenue > 1) {
        const slotUniqueId = slotClicked.availableSlots[0]?.uniqueId;

        // Check if this slot is already selected
        const alreadySelected = selectedSlots.some(slot => slot.uniqueId === slotUniqueId);
        if (alreadySelected) {
          console.log("Already selected this slot");
          this.snackBar.open('You have already requested this slot. Kindly review your booking queue to finalize the booking.', 'Close', {
            duration: 3000,
            panelClass: ['snackbar-error']
          });
          return;
        }

        // Check if booked slots already full
        if (Array.isArray(slotClicked.bookedSlots) && slotClicked.bookedSlots.length >= this.selectedProduct.capacityPerVenue) {
          console.log("Scenario 1 - Booked full");
          this.snackBar.open('This selected slot is fully booked!', 'Close', {
            duration: 3000,
            panelClass: ['snackbar-error']
          });
          return;
        }

        // Safe to proceed
        console.log("Scenario 3 - Slot selected");
        slotClicked.isSelected = true;
        slotClicked.availableSlots[0].isSelected = false;
        this.logicForAddRemove(slotClicked.availableSlots[0]);
        return;
      }

      // SINGLE SLOT CASE
      if (this.selectedProduct.capacityPerVenue <= 1) {
        // slotClicked.isSelected = !slotClicked.isSelected;
        this.logicForAddRemove(slotClicked.availableSlots[0]);
      }
    }

    // Remove from cart logic
    if (action === 'delete') {
      if (slotClicked.availableSlots?.length) {
        slotClicked.isSelected = false;
        slotClicked.isAvailable = true;
        this.logicForAddRemove(slotClicked.availableSlots[0]);
      }
      return;
    }
  }


  logicForAddRemove(slotData) {
    console.log(slotData);
    slotData.isSelected = !slotData.isSelected;
    slotData.isAvailable = !slotData.isAvailable;
    if (slotData.isSelected) {
      console.log("add.....")
      this.adminBookingSvc.addToSelectedSlots(slotData);
    } else {
      console.log("delete.....")
      this.adminBookingSvc.removeFromSelectedSlots({ uniqueId: slotData.uniqueId });
    }
  }
  // onSingleClick(element, dataKey, event) {
  //   console.log(element)
  //   this.isSingleClick = true;
  //   this.singleClickTimeout = setTimeout(() => {
  //     if (this.isSingleClick) {
  //       this.showData(element, dataKey, event);
  //     }
  //   }, 200);
  // }
  // showData(element, dataKey, event) {
  //   const slotClicked = element[dataKey];
  //   if (slotClicked.displayLabel === 'Available') {
  //     slotClicked.isSelected = !slotClicked.isSelected;
  //     slotClicked.isAvailable = !slotClicked.isAvailable;

  //     if (slotClicked.isSelected) {
  //       this.adminBookingSvc.addToSelectedSlots(slotClicked);
  //     } else {
  //       this.adminBookingSvc.removeFromSelectedSlots({ uniqueId: slotClicked.uniqueId });
  //     }
  //   }
  //   if (event && (slotClicked.displayLabel === 'Unavailable' || slotClicked.displayLabel === 'Available')) {
  //     event.stopPropagation();
  //   } else if (event) {
  //     this.dialog.open(BookedDetailsComponent, {
  //       data: slotClicked
  //     });
  //   }
  // }

  // onDblClick() {
  //   this.isSingleClick = false;
  //   if (this.singleClickTimeout) {
  //     clearTimeout(this.singleClickTimeout);
  //     this.bookNow();
  //   }
  // }

  bookNow() {
    this.dialog.open(BookSelectedSlotsComponent, {
      width: '600px',
      data: {}
    });
  }

  formSlotData() {
    const sessionData = this.bookingData;
    if (!sessionData) {
      return;
    }
    const availableSlots = sessionData.availableSlots;
    const bookedSlots = sessionData.bookedSlots;

    if (availableSlots && availableSlots.length > 0) {
      availableSlots.forEach((availableSlot) => {
        if (availableSlot.uniqueId) {
          const yearStrLength = 4;
          const dateLength = 10;
          const uniqueId = availableSlot.uniqueId;
          const indexOfFirstHyphen = uniqueId.indexOf('-');
          const dateKey = uniqueId.substr(indexOfFirstHyphen - yearStrLength, dateLength);
          const slotDate = new Date(dateKey);
          const startTime = availableSlot.startTime.split(':');
          slotDate.setHours(startTime[0]);
          slotDate.setMinutes(startTime[1]);
          const currentTime = new Date().getTime();
          if (slotDate.getTime() >= currentTime) {
            this.parseSlotData(availableSlot, 'available');
          }
        }
      });
    }
    if (bookedSlots && bookedSlots.length > 0) {
      bookedSlots.forEach((bookedSlot) => {
        this.parseSlotData(bookedSlot, 'Booked');
      });
    }
  }

  // updateDataSource() {
  //   this.dayColumns.forEach((column) => {
  //     this.dataSource.forEach(rowData => {
  //       if (!rowData[column]) {
  //         rowData[column] = {
  //           displayLabel: '--',
  //           isAvailable: false,
  //           isSelected: false,
  //           isBooked: false,
  //           availableSlots: [],
  //           bookedSlots: []
  //         };
  //       }

  //       if (this.slotDetails[rowData.dateTime] && this.slotDetails[rowData.dateTime][column]) {
  //         const slotData = this.slotDetails[rowData.dateTime][column];

  //         if (slotData) {
  //           // Handle available slots
  //           if (slotData.availableSlots && slotData.availableSlots.length > 0) {
  //             rowData[column].availableSlots = slotData.availableSlots;
  //             rowData[column].isAvailable = true;

  //             // Check if any slot is selected
  //             const hasSelectedSlot = slotData.availableSlots.some(slot => slot.isSelected);
  //             if (hasSelectedSlot) {
  //               rowData[column].isSelected = true;
  //             }

  //             // Set price to first available slot's price (for display)
  //             rowData[column].price = slotData.availableSlots[0].price;
  //           }

  //           // Handle booked slots
  //           if (slotData.bookedSlots && slotData.bookedSlots.length > 0) {
  //             rowData[column].bookedSlots = slotData.bookedSlots;
  //             rowData[column].isBooked = true;

  //             // Set customer name and price from first booked slot (for display)
  //             if (slotData.bookedSlots[0]) {
  //               rowData[column].customerName = slotData.bookedSlots[0].customerName;
  //               rowData[column].price = slotData.bookedSlots[0].price;
  //             }
  //           }

  //           // Set display label
  //           if (rowData[column].isBooked) {
  //             rowData[column].displayLabel = 'Booked';
  //           } else if (rowData[column].isAvailable) {
  //             rowData[column].displayLabel = 'Available';
  //           } else {
  //             rowData[column].displayLabel = '--';
  //           }
  //         }
  //       }
  //     });
  //   });
  // }

  updateDataSource() {
    const defaultVenue = 'default';
    const capacity = this.selectedProduct?.capacityPerVenue || 1;

    this.dayColumns.forEach((column) => {
      this.dataSource.forEach(rowData => {
        if (!rowData[column]) {
          rowData[column] = {};
        }

        if (!rowData[column][defaultVenue]) {
          rowData[column][defaultVenue] = {
            displayLabel: '--',
            isAvailable: false,
            isSelected: false,
            isBooked: false,
            isPartiallyBooked: false,
            availableSlots: [],
            bookedSlots: [],
            selectedSlots: []
          };
        }

        const slotData = this.slotDetails[rowData.dateTime]?.[column];
        if (slotData) {
          const cell = rowData[column][defaultVenue];

          // Available slots
          if (slotData.availableSlots?.length > 0) {
            cell.availableSlots = slotData.availableSlots.map(slot => ({
              ...slot,
              isAvailable: !slot.isSelected,
            }));

            cell.isAvailable = true;
            const selectedSlots = slotData.availableSlots.filter(slot => slot.isSelected);
            if (selectedSlots.length > 0) {
              cell.isSelected = true;
            }

            // Optional: add selectedSlots separately
            cell.selectedSlots = selectedSlots;

            // Display price of first available
            cell.price = slotData.availableSlots[0]?.price;
          }

          // Booked slots
          if (slotData.bookedSlots?.length > 0) {
            cell.bookedSlots = slotData.bookedSlots.map(slot => ({
              ...slot,
              isAvailable: false
            }));

            const bookedCount = slotData.bookedSlots.length;
            if (bookedCount >= capacity) {
              cell.isBooked = true;
              cell.isPartiallyBooked = false;
            } else {
              cell.isPartiallyBooked = true;
              cell.isBooked = false;
              cell.isAvailable = true;
            }

            // Optional: display first customer
            if (slotData.bookedSlots[0]) {
              cell.customerName = slotData.bookedSlots[0].customerName;
              cell.price = slotData.bookedSlots[0].price;
            }
          }

          // Final display label logic
          if (cell.isBooked) {
            cell.displayLabel = 'Booked';
          } else if (cell.isPartiallyBooked) {
            cell.displayLabel = 'Partially Booked';
          } else if (cell.isAvailable) {
            cell.displayLabel = 'Available';
          } else {
            cell.displayLabel = '--';
          }
        }
      });
    });
  }

  getSlotId(data, dateKey) {
    return data.tenantId + '_' + data.productId   + '_' + dateKey.slice(5) + '_' +
                 data.startTime + '_' + data.endTime + '_' + data.venueId;
  }

  addSlotData(data, slotData, type, dateKey) {
    const selectedSlots = JSON.parse(sessionStorage.getItem('selectedSlots'));
    let matchingSlot;
    if (selectedSlots && selectedSlots.length > 0) {
      matchingSlot = selectedSlots.find(selectedSlot => selectedSlot.uniqueId === data.uniqueId);
    }
    if (type === 'available') {
      slotData.availableSlots.push({
        displayLabel: 'Available',
        isSelected: matchingSlot ? matchingSlot.isSelected : false,
        isAvailable: matchingSlot ? matchingSlot.isAvailable : true,
        price: Math.round(data.price),
        slotId: this.getSlotId(data, dateKey),
        tenantId: data.tenantId,
        productId: data.productId,
        productName: this.selectedProduct.name,
        venueName: this.venueName,
        venueId: data.venueId,
        startTime: data.startTime,
        endTime: data.endTime,
        date: dateKey,
        uniqueId: data.uniqueId
      });
    }
    if (type === 'Booked') {
      slotData.bookedSlots.push({
        displayLabel: 'Booked',
        isAvailable: false,
        isSelected: false,
        price: data.amount,
        slotId: this.getSlotId(data, dateKey),
        tenantId: data.tenantId,
        productId: data.productId,
        productName: this.selectedProduct.name,
        venueName: this.venueName,
        venueId: data.venueId,
        customerName: data.username,
        customerEmail: data.email,
        customerPhone: data.phoneNumber,
        bookingId: data.confirmationId,
        bookingDate: data.bookingDate,
        startTime: data.startTime,
        endTime: data.endTime,
        paymentType: data.paymentType,
        bookedOn: data.createdAt,
        notes: data.notes,
        isBooked: true
      });
    }
    return slotData;
  }



  getDateStrFromTime(timeValue) {
    const date = new Date(timeValue);
    return date.getFullYear() + '-' + this.addZeroIfRequired(date.getMonth() + 1) + '-' +
      this.addZeroIfRequired(date.getDate());
  }

  parseSlotData(data, type) {
    if (data.startTime && data.endTime) {
      const yearStrLength = 4;
      const dateLength = 10;
      const uniqueId = data.uniqueId;
      let indexOfFirstHyphen;
      let dateKey;
      if (uniqueId) {
        indexOfFirstHyphen = uniqueId.indexOf('-');
        dateKey = 'date_' + uniqueId.substr(indexOfFirstHyphen - yearStrLength, dateLength);
      } else if (type === 'Booked') {
        dateKey = 'date_' + this.getDateStrFromTime(data.bookingDate);
      }

      if (this.slotDetails[data.startTime] && this.slotDetails[data.startTime][dateKey]) {
        const slotData = this.slotDetails[data.startTime][dateKey];
        this.addSlotData(data, slotData, type, dateKey);
      } else {
        const slotData = {
          availableSlots: [],
          bookedSlots: []
        };
        if (!this.slotDetails[data.startTime]) {
          this.slotDetails[data.startTime] = {};
        }
        this.slotDetails[data.startTime][dateKey] = this.addSlotData(data, slotData, type, dateKey);
      }
    }
  }

  getDayColumns() {
    const dayColumns = [];
    this.dayColumnsObj = [];
    // add past and future 7 days including the current day in the columndData array
    for (let i = 0; i < this.dateRange; i++) {
      const date = this.addXNumberOfDays(this.selectedDate, i);

      /* new Date();
      // increment or decrement the date day based on the i value
      date.setFullYear(this.selectedDate.getFullYear());
      date.setMonth(this.selectedDate.getMonth());
      date.setDate(this.selectedDate.getDate() + i); */

      // const monthWithDate = date.getDate() + ' ' + (date.getMonth() + 1);
      const dateTime = date.getTime();
      const dateFormat = 'date_' + this.getDateFormatWithSeparator(date, '-');
      this.dayColumnsObj.push({
        dateTime: dateTime,
        dateFormat: dateFormat
      });
      // this.dayColumnsObj.push({
      //   date: date
      // });
      // dayColumns.push('time' + dateTime);
      dayColumns.push(dateFormat);
    }
    return dayColumns;
  }

  getDateFormatWithSeparator(date: Date, separator = '-') {
    const year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let day: any = date.getDate();

    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return year + separator + month + separator + day;
  }

  // getDayHeader(timeString = '') {
  //   const splitTimeStr = timeString.split('time');
  //   const dateTime = splitTimeStr && splitTimeStr.length > 0 ? splitTimeStr[1] : null;
  getDayHeader(dateTime) {
    if (dateTime) {
      const dateObj = new Date(dateTime);
      return dateObj.getDate() + ' ' + this.months[dateObj.getMonth()];
    }
    return '';
  }
  // getWeekDay(timeString = '') {
  // const splitTimeStr = timeString.split('time');
  // const dateTime = splitTimeStr && splitTimeStr.length > 0 ? splitTimeStr[1] : null;
  getWeekDay(dateTime) {
    if (dateTime) {
      const dateObj = new Date(dateTime);
      return this.weekdays[dateObj.getDay()]
    }
    return '';
  }

  setAllDayHoursInSource() {
    this.dataSource = [];

    const sessions = this.selectedProduct?.sessions || [];
    if (!sessions.length) return;

    const interval = this.slotInterval || 60; // Default to 60 minutes if not provided
    const minsPerDay = 24 * 60; // Total minutes in a day (24 hours)
    const sessionSlotSet = new Set<number>();

    sessions.forEach(session => {
      let start = this.timeToMinutes(this.convertTo24Hr(session.startTime));
      let end = this.timeToMinutes(this.convertTo24Hr(session.endTime));

      let current = start;

      if (end === 0) end = minsPerDay;
      if (end <= start) {
        // Handle sessions that span midnight, add slots till midnight
        for (let current = start; current < minsPerDay; current += interval) {
          sessionSlotSet.add(current);
        }
        // If needed, add slots from 0 to end on the next day (optional, based on your app logic)
        // For your use case, maybe ignore this to keep slots within a single day only
      } else {
        for (let current = start; current < end; current += interval) {
          sessionSlotSet.add(current);
        }
      }

      // Add only slots that match the interval (e.g., 60 mins)
      // while (current <= end) {
      //   sessionSlotSet.add(current);
      //   current += interval;
      // }
    });

    // Convert sessionSlotSet to an array of sorted dateTimes
    const sessionSlots = Array.from(sessionSlotSet).sort((a, b) => a - b);

    // Now fill in the gaps between session slots
    const finalSlots = [];
    let previousSlot = 0;

    // Ensure we have slots from the beginning of the day to the first session slot
    for (let mins = 0; mins < minsPerDay; mins += interval) {
      const now = new Date();
      const currentMins = now.getHours() * 60 + now.getMinutes();
      const isPast = mins < currentMins;
      if (sessionSlots.length === 0 || mins < sessionSlots[0]) {
        finalSlots.push({ dateTime: `${Math.floor(mins / 60)}:${(mins % 60).toString().padStart(2, '0')}`, isAvailable: !isPast });
      }
    }

    // Add the session slots and check for gaps
    sessionSlots.forEach((slot, index) => {
      if (previousSlot && slot - previousSlot > interval) {
        // If there is a gap, add the missing slots
        let gapStart = previousSlot + interval;
        while (gapStart < slot) {
          finalSlots.push({ dateTime: `${Math.floor(gapStart / 60)}:${(gapStart % 60).toString().padStart(2, '0')}` });
          gapStart += interval;
        }
      }
      finalSlots.push({ dateTime: `${Math.floor(slot / 60)}:${(slot % 60).toString().padStart(2, '0')}` });
      previousSlot = slot;
    });

    // Ensure the last slot to cover up to the end of the day
    let endOfDaySlot = previousSlot + interval;
    while (endOfDaySlot < minsPerDay) {
      finalSlots.push({ dateTime: `${Math.floor(endOfDaySlot / 60)}:${(endOfDaySlot % 60).toString().padStart(2, '0')}` });
      endOfDaySlot += interval;
    }

    this.dataSource = finalSlots;
    this.origDataSource = finalSlots;
  }

  // Converts "4:30 AM" or "5:00 PM" to "4:30" or "17:00"
  convertTo24Hr(time: string): string {
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  }

  timeToMinutes(timeStr: string): number {
    const [h, m] = timeStr.split(':').map(Number);
    return h * 60 + m;
  }

  getFormattedTime(timeString) {
    let formattedTime = '';
    const splitTimeString = timeString.split(':');
    let timeValue = parseInt(splitTimeString[0], 10);
    const minsValue = parseInt(splitTimeString[1], 10);

    if (timeValue >= 12) {
      if (timeValue !== 12) {
        timeValue = timeValue % 12;
      }
      if (minsValue === 0) {
        formattedTime = timeValue + ' PM';
      } else {
        formattedTime = timeValue + ':' + splitTimeString[1] + ' PM';
      }
    } else {
      if (timeValue === 0) {
        timeValue = 12;
      }
      if (minsValue === 0) {
        formattedTime = timeValue + ' AM';
      } else {
        formattedTime = timeValue + ':' + splitTimeString[1] + ' AM';
      }
    }
    return formattedTime;
  }

  ngOnDestroy() {
    if (this.bookingSlotsSubscription) {
      this.bookingSlotsSubscription.unsubscribe();
    }
    if (this.reloadDataSubscription) {
      this.reloadDataSubscription.unsubscribe();
    }
    if (this.selectedSlotRemovedSubscription) {
      this.selectedSlotRemovedSubscription.unsubscribe();
    }
    if (this.pageRefreshSubscriber) {
      this.pageRefreshSubscriber.unsubscribe();
    }
  }

  // 1) is this calendar‐cell’s date before today?
  /** dateKey comes in as "date_YYYY‑MM‑DD" → parse the YYYY‑MM‑DD portion */
  isPastDate(dateKey: string): boolean {
    if (!dateKey) return false;

    const d = dateKey.startsWith('date_')
      ? dateKey.slice(5)           // remove "date_"
      : dateKey;

    const cell = new Date(d);
    const today = new Date();

    // zero‑out time portion for an “all‑day” compare
    cell.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return cell < today;
  }

  // 2) is this one slot’s time before now? (accepts "4:00" or "04:00" or "16:00")
  isPastTime(timeStr: string): boolean {
    if (!timeStr) return false;
    // split into [hour, minute] and convert
    const parts = timeStr.split(':').map(p => parseInt(p, 10));
    if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return false;
    const [hours, mins] = parts;
    const slotMins = hours * 60 + mins;
    const now = new Date();
    const nowMins = now.getHours() * 60 + now.getMinutes();
    return slotMins < nowMins;
  }

  // 3) combine date & time into “past slot?”
  isPastSlot(dateKey: string, startTime: string): boolean {
    if (this.isPastDate(dateKey)) return true;

    // if it’s exactly today compare times
    const cellDate = (dateKey.startsWith('date_') ? dateKey.slice(5) : dateKey);
    if (new Date(cellDate).toDateString() === new Date().toDateString()) {
      return this.isPastTime(startTime);
    }

    return false;  // future date
  }

  // 4️⃣ update your getSlotClass to force 'unavailable-slot' for past cells
  getSlotClass(slotData: any, dateKey: string): string {
    if (!slotData) {
      return 'unavailable-slot';
    }

    // determine startTime from whichever array has it
    const st = slotData.availableSlots?.[0]?.startTime
      || slotData.bookedSlots?.[0]?.startTime;

    if (st && this.isPastSlot(dateKey, st)) {
      return 'booked-slot';
    }

    if (slotData.isSelected) {
      return 'selected-slot';
    } else if (slotData.isBooked) {
      return 'booked-slot';
    } else if (slotData.isPartiallyBooked) {
      return 'partially-booked-slot';
    } else if (slotData.isAvailable) {
      return 'available-slot';
    } else {
      return 'unavailable-slot';
    }
  }

  // Allow menu only when it's a multi-slot product and slot has data
  canOpenMenu(slot: any): boolean {
    return this.selectedProduct?.capacityPerVenue > 1
      && !!slot
      && (slot.isAvailable || slot.isBooked || slot.isSelected);
  }

  // Used when mouse is pressed (single click equivalent)
  handleMouseDown(element: any, dateFormat: string, event: MouseEvent, venueName: string): void {
    const slot = element[dateFormat][venueName];
    this.selectedSlot = slot;

    if (this.canOpenMenu(slot)) return; // Let menu handle interaction

    if (slot.isBooked) {
      this.showDetails(element, dateFormat, event, venueName);
    } else if (slot.isAvailable && !slot.isSelected) {
      this.addToCart(element, dateFormat, event, venueName);
    } else if (slot.isSelected) {
      this.removeFromCart(element, dateFormat, event, venueName);
    }
  }

  // Handle double click explicitly
  handleDoubleClick(element: any, dateFormat: string, event: MouseEvent, venueName: string): void {
    const slot = element[dateFormat][venueName];
    this.selectedSlot = slot;

    if (this.canOpenMenu(slot)) {
      this.onDblClick();
    }
  }

  // Double-click handler
  onDblClick(): void {
    this.isSingleClick = false;

    if (this.singleClickTimeout) {
      this.slotMenuTrigger?.closeMenu(); // Safely close menu
      clearTimeout(this.singleClickTimeout);
      this.bookNow(); // Your existing booking logic
    }
  }

  // Show booking details (used for booked slots)
  showDetails(element: any, dateFormat: string, event: MouseEvent, venueName: string): void {
    console.log("Show Details:", this.selectedSlot);
    this.onSingleClick(element, dateFormat, event, venueName, 'view');
  }

  // Add slot to cart (used for available slots)
  addToCart(element: any, dateFormat: string, event: MouseEvent, venueName: string): void {
    console.log("Add to Cart:", this.selectedSlot);
    this.onSingleClick(element, dateFormat, event, venueName, 'add');
  }

  // Remove slot from cart (used for selected slots)
  removeFromCart(element: any, dateFormat: string, event: MouseEvent, venueName: string): void {
    console.log("Remove from Cart:", this.selectedSlot);
    this.onSingleClick(element, dateFormat, event, venueName, 'delete');
  }

  remainingSlots(bookedSlots) {
    let remainingSlot = 0;
    if (this.selectedProduct.capacityPerVenue && bookedSlots && bookedSlots.length) {
      remainingSlot = this.selectedProduct.capacityPerVenue - bookedSlots.length;
    }
    return remainingSlot;
  }
}
